
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Tooltip from '@/components/UI/Tooltip.vue';
import PrinterListDialog from '@/components/dialogs/PrinterListDialog.vue';
import { AirroadJobDetailed } from '@/models/airRoad';
import { printAirRoad } from '@/api';

@Component({
  components: {
    Tooltip,
    PrinterListDialog,
  },
})
export default class PrintActionBtn extends Vue {
  @Prop(Object) public arJob: AirroadJobDetailed;
  @Prop(Boolean) public isAirRoadBooked: boolean;

  public isShow = false;

  public get title(): string {
    return `AirRoad job ${this.arJob.connote}: Choose a printer`;
  }

  public printRequest(printerId: number): Promise<AxiosResponse> {
    return printAirRoad({ id: this.arJob.id, printer_id: printerId });
  }

  public handlePrintClick(event: Event) {
    event.stopPropagation();
    this.isShow = true;
  }

  public handleDialogClose() {
    this.isShow = false;
  }
}
